
import { MODULE } from "@/config/modules";
import { BrowseService } from "@/services";
import { AuthService } from "@/services/auth-service";
import { ReportEngineSettings, ReportType } from "@/utils/report-engine-settings/report-engine-settings";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>ReportEngineSettings,
			required: true
		}
	},
	computed: {
		isSupportSession():boolean {
			return AuthService.isDevModeEnabled;
		},
		manualPreloadString():string{
			return this.value.ManualPreloads.join(", ");
		},
		reportTypeItems():ISelectItem<ReportType>[]{
			let result = [{
				text: "PDF",
				value: "pdf"
			}] as ISelectItem<ReportType>[];

			if (AuthService.hasModule(MODULE.EXPORT_NAAR_EXCEL)){
				result.push({
					text: "Excel",
					value: "excel"
				});
			}

			return result;
		},
		browseHasBookYearFilter():boolean {
			if (this.value.isSourceTypeScript()) return false;
			let browseId = this.value.getBrowseIDFromDataSource();
			let browse = BrowseService.browses.find(b=>b.ID == browseId);
			if (!browse) return false;
			return browse.HasBookYearFilter;
		}
	},
	methods: {
		async setDontRequireBookYearSelection(value:boolean){
			this.value.DontRequireBookYearSelection = !value;
			if (!value) {
				let message = this.$ct("are-you-sure-you-want-to-use-all-bookyears-this-can-be-slow");
				let confirm = await this.$confirmBuilder().setWarningTitle().setMessage(message).show();
				if (!confirm) {
					this.value.DontRequireBookYearSelection = false;
					return;
				}
			}
		},
		setManualPreloads(value:string){
			this.value.ManualPreloads = value.split(",").map(v=>v.trim());
		}
	},
	i18nEx: {
		componentPrefix: "components.reportengine"
	}
});
